import React from 'react';

import SplashScreen from '../widgets/SplashScreen';

function LoadingPage() {
    return <SplashScreen />;
}

export default LoadingPage;



// WEBPACK FOOTER //
// ./src/components/pages/LoadingPage.js